import { Component, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import { UserPreferencesService } from 'src/app/services/user-preferences.service';
import Changeover from 'src/models/changeover';
import Task from 'src/models/task';
import { TaskListItemComponent } from './task-list-item/task-list-item.component';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent {
  selectedTaskId: string | null = null;

  model: Changeover | null = null;
  @Input('model')
  set modelSetter(value: Changeover | null) {
    this.model = value;

    const options = this.assignees;
    const previousSelected = this.preferences.changeoverTaskListSelectedAssignees;

    if (previousSelected && previousSelected.length > 0) {
      const relevantAssignees = options.filter(item => previousSelected.includes(item))
      this.selectedAssignees = relevantAssignees;
    } else {
      this.selectedAssignees = options;
    }
  }

  @Output() taskSelected = new EventEmitter<Task | null>();

  @ViewChild('list')
  list!: MatSelectionList;

  @ViewChildren('listItem')
  listItems!: QueryList<TaskListItemComponent>;

  constructor(private preferences: UserPreferencesService) { }

  get assignees(): string[] {
    const result = Array.from(new Set<string>(this.model?.tasks.flatMap(item => item.assignees) || []).values());
    result.sort();
    return result;
  }

  _selectedAssignees: string[] = [];
  get selectedAssignees() { return this._selectedAssignees; }
  set selectedAssignees(value: string[]) {
    this._selectedAssignees = value;
    this.preferences.changeoverTaskListSelectedAssignees = value;
  }

  onSelectionChange(): void {
    const selection: Task | null = this.list.options.filter(item => item.selected)[0]?.value as Task || null;
    this.selectedTaskId = selection?.id || null;
    this.taskSelected.emit(selection);
  }

  isTaskDisabled(task: Task) {
    return this.model?.isFinalised || !task.assignees.some(item => this.selectedAssignees.includes(item));
  }

  refreshTask(taskId: string) {
    if (this.listItems) {
      const target = this.listItems?.find(item => item.model.id == taskId);
      target?.refresh();
    }
  }
}
